import React from 'react';
import { partnerBanks } from '../../data/mock';

// Bank logo image from customer assets
const bankLogosImage = "https://customer-assets.emergentagent.com/job_kredithilfe-1/artifacts/ftndzr2v_%7B93C3A8D5-F2C7-449F-8AE9-E6F9E88C9910%7D.png";

const PartnerBanks = () => {
  return (
    <section className="py-16 bg-slate-50 border-y border-slate-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Vertrauenspartner</span>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-2">
            Über 500 renommierte Partnerbanken
          </h2>
          <p className="text-slate-600 mt-2">
            Wir arbeiten mit den führenden Kreditinstituten Deutschlands zusammen
          </p>
        </div>

        {/* Bank Logos Image Strip */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8">
          <div className="flex justify-center items-center">
            <img 
              src={bankLogosImage} 
              alt="Unsere Partnerbanken" 
              className="max-w-full h-auto object-contain"
              style={{ maxHeight: '80px' }}
            />
          </div>
        </div>

        {/* Additional info */}
        <div className="text-center mt-8">
          <p className="text-sm text-slate-500">
            ... und viele weitere Partnerbanken für Ihre optimale Finanzierungslösung
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnerBanks;
